import React from "react";
import { Helmet } from "react-helmet";

import { CONTACT_DETAILS } from "../../utils/stateTypes";

const styles = {
  page: {
    padding: "56px var(--gutter) 96px var(--gutter)",
    maxWidth: 760,
  },
  title: {
    margin: "0 0 32px 0",
    fontFamily: "var(--font-display)",
    fontWeight: 400,
    fontSize: "clamp(2.2rem, 5vw, 2.8rem)",
    textAlign: "center",
  },
};

//TODO: The original site's privacy policy page was empty - replace this with the client's policy once supplied
const PrivacyPolicy = () => {
  return (
    <div
      className={"container"}
      style={styles.page}
    >
      <Helmet>
        <title>Privacy Policy | PM Skills Foundation</title>
      </Helmet>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p>
        Our full privacy policy is being updated. If you have any questions about how we use the personal
        information you send us, please email{" "}
        <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
